import React, { FunctionComponent } from 'react';
import styles from './Initiatives.module.scss';
import { Block, BlockContent, Icon, Typography } from 'components/elements';
import { WPAcfInitiatives } from 'types/acf/initiatives';
import DOMPurify from 'dompurify';
import { Polygon as PolygonIcon } from 'assets/icons';
import Initiative from './Initiative';

interface OwnProps {
  data: WPAcfInitiatives | null;
}

type InitiativesProps = JSX.IntrinsicElements['div'] & OwnProps;

const Initiatives: FunctionComponent<InitiativesProps> = props => {
  const { data: initiativesData } = props;

  if (!initiativesData) {
    return null;
  }

  const { header, initiatives } = initiativesData;

  return (
    <Block id="initiatives" theme="white" data-module="initiatives">
      <BlockContent>
        <div className={styles.wrapper}>
          {header && (
            <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="div" className={styles.header}>
              <Icon size={35} icon={PolygonIcon} />
              <h4>{DOMPurify.sanitize(header)}</h4>
            </Typography>
          )}
          {initiatives?.map((initiative, index) => (
            <Initiative initiativeIndex={index} key={`initiative-item-${index}`} data={initiative} />
          ))}
        </div>
      </BlockContent>
    </Block>
  );
};

export default Initiatives;
